// 定义一个 Stack 类
export default class Stack {
    // 构造函数接收一个 maxSize 参数，用于设置栈的最大容量
    constructor(maxSize) {
        // 设置栈的最大容量
        this.maxSize = maxSize;
        // 初始化一个空数组来存储栈元素
        this.stack = [];
    }

    // push 方法用于向栈中添加元素
    push(item) {
        // 如果栈的当前大小已经达到最大容量
        if (this.stack.length >= this.maxSize) {
            // 移除栈底的元素（数组的第一个元素）
            this.stack.shift();
        }
        // 将新元素添加到栈顶（数组的末尾）
        this.stack.push(item);
    }

    // pop 方法用于从栈中移除并返回栈顶元素
    pop() {
        return this.stack.pop();
    }

    // display 方法用于返回栈的所有元素
    display() {
        return this.stack;
    }
}
